import React from 'react';
import classNames from 'classnames';
import {
  DATA_ROOM_NODE_SHORT_TAGS,
  DataRoomNodeTag as Tag,
} from 'router/subrouters/DataRoom/models/DataRoomNode';
import { useTranslation } from 'react-i18next';
import { getIsRevisedVersion } from 'utils';

import './DataRoomNodeTagAndVersion.styles.scss';

type DataRoomNodeTagAndVersionProps = {
  className?: string;
  tag?: Tag;
  version?: number;
};

const DataRoomNodeTagAndVersion: React.FC<DataRoomNodeTagAndVersionProps> = (
  props,
) => {
  const { className, tag, version } = props;

  const versionClasses = classNames('data-room-node-version', className);
  const tagClasses = classNames('data-room-node-tag', className);

  const { t } = useTranslation();

  const showVersion = getIsRevisedVersion(version);

  if (!tag && !showVersion) return null;

  return (
    <>
      {showVersion && <span className={versionClasses}>v{version}</span>}
      {tag && (
        <span className={tagClasses}>
          {t(DATA_ROOM_NODE_SHORT_TAGS[tag]) || tag}
        </span>
      )}
    </>
  );
};

export default DataRoomNodeTagAndVersion;
